import {
    ON_START_IMPORT_ITESCO,ON_IMPORT_ITESCO,ON_ERROR_IMPORT_ITESCO,
}
from "../constants/ActionTypes";
import axios from 'util/Api'
//import axios from 'util/ApiDialer' 
import { history } from "store";
import {isUndefined} from 'lodash'


const getClientIp = async () => {
  let Ipadress='0.0.0.0'
    /*  await fetch('https://geolocation-db.com/json/')
    .then(response => response.json())
    .then(data => {console.log(data)
      Ipadress= data.IPv4});
      */
      return Ipadress
}
//importeraFunctionItesco
export const importeraFunctionItesco = (userid,NewState) =>{
    const jwt =  JSON.parse(localStorage.token);
  //  let files = NewState.ExcelFile.file; 
  //  var fromdata = new FormData();
  //  fromdata.append("userid",userid)
  //  fromdata.append("function",NewState.function)
  //  fromdata.append("Agare",NewState.ExcelFile.userid)
   // files.forEach(file => fromdata.append('files[]', file));
    return async (dispatch) => {
      dispatch({type: ON_START_IMPORT_ITESCO});
      axios.post('kontos/Itesco/Import',
   //   fromdata,
       {
         body:{
            userid:userid,
            function:NewState.function,
           // Agare:NewState.ExcelFile.userid,
         },
         headers: {
            //'content-type': 'application/json',
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
          }
       }
       ).then(({data}) => {
      console.log("importeraFunctionItesco: ", data);
       if (data) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_IMPORT_ITESCO, payload: data});
       } else {
         dispatch({type: ON_ERROR_IMPORT_ITESCO, payload: data.message});
       }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_IMPORT_ITESCO, payload: error.message});
       console.log("Error****:", error.message);
     });
    } 
   }

   export const importFriaFalt = (ObjId, file, Afid, Userid, Orgnr) => {
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
    var formData = new FormData();
    const ipAdress=await getClientIp()
    formData.append("files[]", file)
    formData.append("ObjId", ObjId)
    formData.append("Afid", Afid)
    formData.append("Userid", Userid)
    formData.append("Orgnr", Orgnr)
    formData.append("ipAdress", ipAdress)
    
      axios.post('friafalt/import/post',
      formData,
       {
         body:{
            ObjId,
            Afid,
            Userid,
            Orgnr,
            ipAdress
         },
         headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization':   `Bearer ${jwt}`
          }
       }
       ).then(({data}) => {
        console.log(data)
     }).catch(function (error) {
       console.log("Error****:", error.message);
     });
    } 
   }